import React, { Component } from 'react';
import styled from 'styled-components';
import NoteFilters from '../FiltersFields';
import { I18n } from 'react-redux-i18n';

const Container = styled.div`
  background-color: ${(props) => props.theme.colors['white']};
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;

  .searchFilterNoteContainer {
    margin-top: 20px;
  }
`;

class FilterBloc extends Component {
  constructor(props) {
    super(props);
    this.state = {
      wine: '',
      vintages: '',
      designation: '',
      rank: '',
      view: '',
      wineOptions: [],
      vintagesOptions: [],
      designationOptions: [],
      rankingOptions: [],
      viewOptions: []
    };
  }

  componentDidMount() {
    const {
      wineFilter,
      vintagesFilter,
      designationFilter,
      rankingFilter,
      viewFilter
    } = this.props;

    this.setState({
      wineOptions: wineFilter,
      vintagesOptions: vintagesFilter,
      designationOptions: designationFilter,
      rankingOptions: rankingFilter,
      viewOptions: viewFilter
    });
  }

  render() {
    const {
      wine,
      vintage,
      appellation,
      rank,
      options,
      onChange,
      display,
      onChangeRadio,
      disableRadio,
      handleChangeCall
    } = this.props;

    return (
      <Container marginBottom={this.props.marginBottom}>
        <NoteFilters
          wineFilter={{
            selectedOption: wine,
            options: options.wine,
            onChange: (selectedOption) => onChange('wine', selectedOption),
            isClearable: false,
            label: I18n.t('notes.compare.filters.wine'),
            placeholder: I18n.t('placeholderAll')
          }}
          vintagesFilter={{
            selectedOption: vintage,
            options: options.vintage.concat().sort(function (a, b) {
              return b.value - a.value;
            }),
            onChange: (selectedOption) => onChange('vintage', selectedOption),
            isClearable: false,
            label: I18n.t('notes.compare.filters.vintage'),
            placeholder: I18n.t('placeholderAll')
          }}
          appellationFilter={{
            selectedOption: appellation,
            options: options.appellation,
            onChange: (selectedOption) =>
              handleChangeCall('appellation', selectedOption),
            label: I18n.t('notes.compare.filters.appellation'),
            placeholder: I18n.t('placeholderAll')
          }}
          rankFilter={{
            selectedOption: rank,
            options: options.rank,
            onChange: (selectedOption) =>
              handleChangeCall('rank', selectedOption),
            label: I18n.t('notes.compare.filters.rank'),
            placeholder: I18n.t('placeholderAll')
          }}
          displayRadioGroup={{
            disabled: disableRadio,
            label: I18n.t('notes.compare.filters.display'),
            radioButtons: display,
            onChange: (label) => onChangeRadio(label)
          }}
        />
      </Container>
    );
  }
}

export default FilterBloc;
